export const PATHWAY_RESPONSE_DEFAULT_SORT = {
  sortedColumn: 'checkInDate',
  sortedColumnOrder: 'descend'
}

export const PATHWAY_ADDITIONAL_FIELDS = [
  'alertPriority',
  'cmAlertText',
  'orderNumber',
  'patientAlertText',
  'respondTime'
]
export const PATHWAY_FIRST_STEP_FIELDS = [
  {
    field: 'diseases',
    saveFields: ['diseases', 'searchClinicalPathway']
  },
  {
    field: 'clinicalPathway',
    saveFields: ['diseases', 'clinicalPathway', 'searchClinicalPathway']
  },
  {
    field: 'searchClinicalPathway',
    saveFields: ['diseases', 'clinicalPathway', 'searchClinicalPathway']
  }
]

export const PATHWAY_PRIORITIES = new Map([
  [0, 'noPriority'],
  [1, 'lowPriority'],
  [2, 'mediumPriority'],
  [3, 'highPriority']
])

export const PATHWAY_PRIORITIES_LABELS = new Map([
  [0, 'No Escalation'],
  [1, 'Low Escalation'],
  [2, 'Medium Escalation'],
  [3, 'High Escalation']
])

export const PATHWAY_TAB_LIST = ['responses', 'patientPathways']
